<template>
<div class="comment">
    <div class="comment-head">
        <div class="statis">评价({{ totalCount }})</div>
        <template v-if="commentList.length>0">

            <el-button plain size="mini" @click="addComment">我要评价</el-button>
        </template>
    </div>
    <div class="filter-cont">
        <div class="item" :class="{active:filterType==0}" @click="filterChange(0)">全部</div>
        <div class="item" :class="{active:filterType==1}"  @click="filterChange(1)">带图</div>
        <div class="item" :class="{active:filterType==2}"  @click="filterChange(2)">好评</div>
        <div class="item" :class="{active:filterType==3}" @click="filterChange(3)">一般</div>
        <div class="item" :class="{active:filterType==4}" @click="filterChange(4)">差评</div>
        
    </div>
    <template v-if="commentList.length>0 && !postLoading">
        <div class="comment-info">
            <CommentItem v-for="comment in commentList" :key="comment.id" :comment="comment" @writeComment="replyComment" @delItem="delItem" />
        </div>
        <div class="view-more" @click="loadMore" v-if="(postLoading == false) && hasMore" >查看更多评价</div>
        <div class="data-loading" v-if="postLoading"><i class="el-icon-loading"></i>数据正在加载中</div>
        <div class="not-more" v-if="hasMore == false">没有更多了</div>
        <DialogCommentPost :status.sync="commentStatus" :post="post" :parentCommentId="parentCommentId" @success="getList"  />
    </template>
    <template v-if="commentList.length==0 && !postLoading">
        <CommentPost :post="post" @submit="getList" />
    </template>


    <DialogCommentReply :status.sync="commentReplyStatus" :post="post" :parentCommentId="parentCommentId" @success="getList" />
</div>
</template>
<script>
import DialogCommentPost from './dialoag-comment-post.vue'
import CommentItem from './comment-item.vue'
import CommentPost from './comment-post.vue'
import DialogCommentReply from './dialog-comment-reply.vue'
export default {
    name:'TabCommentPage',
    props:{
        post:{
            type:Object,
            default:{}
        }
    },
    components:{
        DialogCommentPost,
        CommentItem,
        CommentPost,
        DialogCommentReply,
    },
    data(){
        return {
            commentStatus:false,
            commentReplyStatus:false,
            hasMore:true,
            params:{
                postId:'',
                offset:1,
                size:10,
                "imageCount": 0, // 1表示只要有图评论，0表示全部
                "starsLevel": 0, // 3 好评, 2 一般， 1 差评，0 全部
            },
            commentList:[],
            totalCount:0,  
            parentCommentId:0,
            postLoading:true,
            filterType:0,
        }
    },
    created(){
        
        this.params.postId = this.post.id;
        this.getList();
    },
    methods:{
        filterChange(typeId){
            if( typeId == this.filterType) return ;
            this.filterType = typeId;
            this.params.imageCount = 0;
            this.params.starsLevel = 0;
            if( typeId == 1 ){
                this.params.imageCount = 1;
            }
            if( typeId == 4) this.params.starsLevel =1;
            if( typeId == 3) this.params.starsLevel = 2;
            if( typeId == 2) this.params.starsLevel = 3;
            this.params.offset = 1;
            this.getList();
        },
        async getList(){
            this.postLoading = true;
            let result = await this.$axios.post('/comment/frontend/v1/get/comment/list',this.params);
            
            
            if( result.code == 0 ){
                if( this.params.offset == 1 ){
                    this.commentList = [];
                }
                this.commentList = this.commentList.concat(result.data.comments);
                this.totalCount = result.data.total;
                
                if( this.commentList.length == this.totalCount)
                this.hasMore = this.commentList.length != this.totalCount;
                
            }
            this.postLoading = false;
        },
        addComment(){
            this.commentStatus= true;
            this.parentCommentId = 0;
        },
        //对评论进行评论
        replyComment(obj){
            this.commentReplyStatus= true;
            this.parentCommentId = obj.id;
        },
        delItem(id){
            
            var isHas = false;
            for(var i=0; i<this.commentList.length;i++){
                if( this.commentList[i].id == id ){
                    this.commentList.splice(i,1);
                    break;
                }
                let childList = this.commentList[i].children||[];
                
                if( childList.length == 0 ) continue;
                for(var l=0;l<childList.length;l++){
                    if( childList[l].id == id){
                        this.commentList[i].children.splice(l,1);
                        
                        isHas = true;

                        break
                    }
                }
                if( isHas) break;
            }
            
        },
        loadMore(){
            this.params.offset++;
            this.getList();
        }
    }
}
</script>
<style lang="scss" scoped>
.comment-head{
    display: flex; justify-content: space-between;  align-items: center;
}
.view-more{font-size: 14px; line-height: 40px; background: #eee; text-align: center; cursor: pointer; user-select: none;}
.not-more{text-align: center; color: #999;font-size: 14px; line-height: 40px;}
.data-loading{display: flex; height: 40px; justify-content: center; align-items: center; color: #999; font-size: 14px;
    i{margin-right: 5px;}
}
.filter-cont {
    display: flex; align-items: center;
    padding: 20px 0;
    .item{
        font-size: 14px; line-height: 30px; padding: 0 10px; border: 1px solid #dcdfe6; color: #606266; border-radius: 4px; margin-right: 10px;
        user-select: none; cursor: pointer;
        &:hover{
            background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
        }
        &.active{
            background: #fef0f0; color: #f56c6c; border-color: #fbc4c4;
        }
    }
}
</style>